export default "__VITE_ASSET__D4GDu2qW__"